import { populate } from 'populate'; import dragonBones from 'pixi-dragonbones';

const raw = {
  className: '',
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: 'ca816ee2-2612-4e37-be37-74c40d43de14',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '128eec44-5f96-4016-a315-bb45921a96bd',
      type: 'Sprite',
      name: 'RewardGlow',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'fx_ray_rewards',
      parent: 'ca816ee2-2612-4e37-be37-74c40d43de14',
      data: ''
    },
    {
      id: 'f62988a0-ceb7-4c7d-a06a-c25d0a76d139',
      type: 'Sprite',
      name: 'RewardIcon',
      nameSpace: '',
      className: '',
      x: 69,
      y: 63,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gas_can_reward',
      parent: 'ca816ee2-2612-4e37-be37-74c40d43de14',
      data: ''
    },
    {
      id: '049996ce-75ae-4531-a95f-8ae1df34016f',
      type: 'Text',
      name: 'RewardText',
      nameSpace: '',
      className: '',
      x: 69,
      y: 106,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x2',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'MyriadProBlack',
        fill: 'white',
        stroke: '#8d3321',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'ca816ee2-2612-4e37-be37-74c40d43de14',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class SeasonPassRewardReminder {
  static raw = raw;
  root: PIXI.Container
  RewardGlow: PIXI.Sprite
  RewardIcon: PIXI.Sprite
  RewardText: PIXI.Text

  constructor() {
    populate(this, raw);
  }
}
